// 20-05-2025
export const USER_SELECTED = "USER_SELECTED";

export const ADD_USER_ID = "ADD_USER_ID";

export const  REMOVE_USER_ID = "REMOVE_USER_ID"

export const RESET_USER = "RESET_USER";